export default {
  FILTER_SET: 'FILTER_SET',
  SELECT_CATEGORY: 'SELECT_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
  REMOVE_SUBCATEGORY: 'REMOVE_SUBCATEGORY',
  REMOVE_ATTRIBUTE: 'REMOVE_ATTRIBUTE',
  SELECT_SUBCATEGORY: 'SELECT_SUBCATEGORY',
};



// WEBPACK FOOTER //
// ./src/store/filters/filters.mutationlist.js